/**
 * A LOCAL date from numeric parts, with NO two-digit-year rule.
 *
 * `new Date(y, m, d)` reads a year 0-99 as 1900-1999, so a stored "10/26/0003" became 1903-10-26 (SCHED-YEAR-1: staff read "1903, not
 * 2026" off a schedule block saved with year 0003). `setFullYear(year, month, day)` has no such rule, and rolls an out-of-range
 * month or day over exactly as the constructor does for any year of 100 or more, so replacing `new Date(y, m - 1, d)` with this
 * changes nothing for a normal year and stops a year 0-99 from turning into a different, plausible-looking one.
 *
 * It does NOT validate: an impossible day still rolls over (callers that need a real date compare the parts back, as before),
 * and a year of 3 is year 3, which every range check downstream can then see for what it is.
 *
 * @param {number} year the full year (0003 is year 3, not 1903)
 * @param {number} month the month, 1-12 (NOT zero-based, unlike the Date constructor)
 * @param {number} day the day of the month
 * @param {number} hours 0-23
 * @param {number} minutes 0-59
 * @param {number} seconds 0-59
 * @param {number} ms 0-999
 * @return {Date} the local date
 */
export function localDateFromParts(year: number, month: number, day: number, hours = 0, minutes = 0, seconds = 0, ms = 0): Date {
  const date = new Date(2000, 0, 1);
  date.setFullYear(year, month - 1, day);
  // The time is set AFTER the date so an overflowing time (25:61) carries into the date like the constructor, not into the 2000 placeholder.
  date.setHours(hours, minutes, seconds, ms);
  return date;
}
